import {html} from 'lit';

import {
	selectOlivioDesign,
	selectOlivioDesignIsSatisfied, selectOlivioHeadSectionIsSatisfied, selectOlivioMiscSectionIsSatisfied,
} from './olivioSelectors';
import {olivioDesignOptions} from './olivioModel';


export const olivioSectionConfig = [
	{
		id: 'olivioStart',
		label: {
			de: 'Konfigurator',
			en: 'Configurator',
			fr: 'Configurator',
		},
		visual: 'olivio3d',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`
				<olivio-start></olivio-start>`,
		]
	},
	{
		id: 'olivioDesignSelect',
		label: {
			de: 'Design Linie',
			en: 'Design Line',
			fr: 'Design ligne',
		},
		visual: 'olivio3d',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`
				<assistant-list-select
					.title=${{
						de: 'Wählen Sie eine Design Linie',
						en: 'Which design line would you like to choose?',
						fr: 'Choisissez une ligne de design'
					}}
					.options=${olivioDesignOptions}
					action='olivio/setOlivioDesign'
					.selected=${selectOlivioDesign}
					.canBeSelected=${() => true}
					.isSatisfied=${selectOlivioDesignIsSatisfied}></assistant-list-select>`,
		]
	},
	{
		id: 'olivioGeneralLayout',
		label: {
			de: 'Layout',
			en: 'Layout',
			fr: 'Disposition',
		},
		visual: 'olivio3d',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`
				<olivio-general-design-settings></olivio-general-design-settings>
			`,
		]
	},
	{
		id: 'olivioHeadDetail',
		label: {
			de: 'Leuchtenkopf Spezifikation',
			en: 'Luminaire head specification',
			fr: 'Spécification de la tête de luminaire',
		},
		visual: 'olivio3d',
		features: [],
		isSatisfied: selectOlivioHeadSectionIsSatisfied,
		widgets: [
			html`
				<olivio-head-table></olivio-head-table>
				<olivio-head-tabs></olivio-head-tabs>
			`
		]
	},
	{
		id: 'misc',
		label: {
			de: 'Weitere Spezifikation',
			en: 'Further spezification',
			fr: 'Spécification supplémentaire',
		},
		visual: 'olivio3d',
		isSatisfied: selectOlivioMiscSectionIsSatisfied,
		features: [],
		widgets: [
			html`
				<olivio-general-controller-settings></olivio-general-controller-settings>
			`,
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

